export default {
    bind: function(el, binding, vnode) {
        el.event = function(event) {
            // here we check if click was outside the el and its children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it was, call method provided in attribute value
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', el.event)
    },

    unbind: function(el) {
        document.body.removeEventListener('click', el.event)
    },
}
